import React, { useEffect, useState } from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import {
  adminInfinitePayGet, adminInfinitePaySave,
  adminPagarmeGet, adminPagarmeSave,
  adminMercadoPagoGet, adminMercadoPagoSave,
  adminWalletGatewayGet, adminWalletGatewaySave,
  adminAsaasGet, adminAsaasSave,
} from '../../lib/api';

const PagamentosSection = () => {
  const [handle, setHandle] = useState('');
  const [info, setInfo] = useState(null);
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  const [pagarmeInfo, setPagarmeInfo] = useState(null);
  const [chave, setChave] = useState('');
  const [msgPagarme, setMsgPagarme] = useState(null);
  const [busyPagarme, setBusyPagarme] = useState(false);

  const [mpInfo, setMpInfo] = useState(null);
  const [mpToken, setMpToken] = useState('');
  const [msgMp, setMsgMp] = useState(null);
  const [busyMp, setBusyMp] = useState(false);

  const [asInfo, setAsInfo] = useState(null);
  const [asChave, setAsChave] = useState('');
  const [msgAs, setMsgAs] = useState(null);
  const [busyAs, setBusyAs] = useState(false);

  const [gateway, setGateway] = useState('infinitepay');
  const [busyGateway, setBusyGateway] = useState(false);

  useEffect(() => {
    adminInfinitePayGet().then((r) => { setInfo(r); setHandle(r.handle); });
    adminPagarmeGet().then(setPagarmeInfo);
    adminMercadoPagoGet().then(setMpInfo);
    adminAsaasGet().then(setAsInfo);
    adminWalletGatewayGet().then((r) => setGateway(r.pix));
  }, []);

  const salvar = async (e) => {
    e.preventDefault();
    setBusy(true); setMsg(null);
    try {
      const r = await adminInfinitePaySave(handle.trim());
      setInfo(r); setHandle(r.handle);
      setMsg({ ok: true, text: 'Salvo.' });
    } catch (err) {
      setMsg({ ok: false, text: 'Informe uma InfiniteTag válida (sem o $).' });
    } finally { setBusy(false); }
  };

  const salvarPagarme = async (e) => {
    e.preventDefault();
    setBusyPagarme(true); setMsgPagarme(null);
    try {
      const r = await adminPagarmeSave(chave.trim());
      setPagarmeInfo(r); setChave('');
      setMsgPagarme({ ok: true, text: `Salvo (ambiente de ${r.ambiente}).` });
    } catch (err) {
      setMsgPagarme({ ok: false, text: err?.response?.data?.detail || 'Não foi possível salvar a chave.' });
    } finally { setBusyPagarme(false); }
  };

  const salvarMp = async (e) => {
    e.preventDefault();
    setBusyMp(true); setMsgMp(null);
    try {
      const r = await adminMercadoPagoSave(mpToken.trim());
      setMpInfo(r); setMpToken('');
      setMsgMp({ ok: true, text: `Salvo (ambiente de ${r.ambiente}).` });
    } catch (err) {
      setMsgMp({ ok: false, text: err?.response?.data?.detail || 'Não foi possível salvar o Access Token.' });
    } finally { setBusyMp(false); }
  };

  const salvarAs = async (e) => {
    e.preventDefault();
    setBusyAs(true); setMsgAs(null);
    try {
      const r = await adminAsaasSave(asChave.trim());
      setAsInfo(r); setAsChave('');
      setMsgAs({ ok: true, text: `Conectado à conta ${r.conta}.` });
    } catch (err) {
      setMsgAs({ ok: false, text: err?.response?.data?.detail || 'Não foi possível conectar.' });
    } finally { setBusyAs(false); }
  };

  const trocarGateway = async (novo) => {
    if (novo === gateway) return;
    setBusyGateway(true);
    try {
      const r = await adminWalletGatewaySave(novo);
      setGateway(r.pix);
    } finally { setBusyGateway(false); }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <section className="bg-white rounded-2xl border border-slate-100 p-6">
        <h2 className="text-lg font-semibold text-slate-900">Qual usar para o Pix</h2>
        <p className="text-sm text-slate-500 mb-4">O cartão de crédito continua sempre pelo InfinitePay. Isso decide só o botão rápido de Pix na Carteira.</p>
        <div className="flex gap-2">
          <button type="button" disabled={busyGateway} onClick={() => trocarGateway('infinitepay')}
            className={`flex-1 h-11 rounded-full text-sm font-semibold border transition-colors disabled:opacity-60 ${gateway === 'infinitepay' ? 'bg-[#2A5BC7] text-white border-[#2A5BC7]' : 'border-slate-200 text-slate-700 hover:border-[#2A5BC7]'}`}>
            InfinitePay
          </button>
          <button type="button" disabled={busyGateway} onClick={() => trocarGateway('pagarme')}
            className={`flex-1 h-11 rounded-full text-sm font-semibold border transition-colors disabled:opacity-60 ${gateway === 'pagarme' ? 'bg-[#2A5BC7] text-white border-[#2A5BC7]' : 'border-slate-200 text-slate-700 hover:border-[#2A5BC7]'}`}>
            Pagar.me
          </button>
          <button type="button" disabled={busyGateway} onClick={() => trocarGateway('mercadopago')}
            className={`flex-1 h-11 rounded-full text-sm font-semibold border transition-colors disabled:opacity-60 ${gateway === 'mercadopago' ? 'bg-[#2A5BC7] text-white border-[#2A5BC7]' : 'border-slate-200 text-slate-700 hover:border-[#2A5BC7]'}`}>
            Mercado Pago
          </button>
          <button type="button" disabled={busyGateway} onClick={() => trocarGateway('asaas')}
            className={`flex-1 h-11 rounded-full text-sm font-semibold border transition-colors disabled:opacity-60 ${gateway === 'asaas' ? 'bg-[#2A5BC7] text-white border-[#2A5BC7]' : 'border-slate-200 text-slate-700 hover:border-[#2A5BC7]'}`}>
            Asaas
          </button>
        </div>
        {gateway === 'pagarme' && !pagarmeInfo?.tem_chave && (
          <p className="text-xs text-amber-600 mt-3">Pagar.me selecionado, mas a chave abaixo ainda não foi salva — enquanto isso, o Pix cai automaticamente pro InfinitePay.</p>
        )}
        {gateway === 'mercadopago' && !mpInfo?.tem_chave && (
          <p className="text-xs text-amber-600 mt-3">Mercado Pago selecionado, mas o Access Token abaixo ainda não foi salvo — enquanto isso, o Pix cai automaticamente pro InfinitePay.</p>
        )}
        {gateway === 'asaas' && !asInfo?.tem_chave && (
          <p className="text-xs text-amber-600 mt-3">Asaas selecionado, mas a chave abaixo ainda não foi salva — enquanto isso, o Pix cai automaticamente pro InfinitePay.</p>
        )}
      </section>

      <section className="bg-white rounded-2xl border border-slate-100 p-6">
        <h2 className="text-lg font-semibold text-slate-900">Asaas</h2>
        <p className="text-sm text-slate-500 mb-5">Pix com QR code direto na tela da Carteira. Mesma conta Asaas da IEP (taxa fixa por Pix).</p>
        <form onSubmit={salvarAs} className="space-y-4">
          <label className="block">
            <span className="text-sm font-medium text-slate-700">Chave da API</span>
            <Input type="password" className="mt-1" value={asChave} onChange={(e) => setAsChave(e.target.value)} autoComplete="off"
              placeholder={asInfo?.tem_chave ? '•••••••••••••••••• (já salva)' : '$aact_prod_...'} />
            <span className="block text-xs text-slate-500 mt-1">Asaas → Integrações → Chaves de API. Ao salvar, o app confere a conta e cadastra sozinho o aviso de pagamento.</span>
          </label>
          {msgAs && <p className={`text-sm ${msgAs.ok ? 'text-emerald-600' : 'text-red-600'}`}>{msgAs.text}</p>}
          <Button type="submit" disabled={busyAs || !asChave.trim()} className="inn-btn-primary rounded-full h-10 px-6">Conectar</Button>
        </form>
        {asInfo && (
          <div className="mt-5 text-sm text-slate-600 bg-slate-50 rounded-xl p-4 space-y-1">
            <p>Status: {asInfo.tem_chave ? <strong className="text-emerald-600">Conectado {asInfo.conta ? `(${asInfo.conta})` : ''}</strong> : <strong className="text-slate-400">Nenhuma chave salva</strong>}</p>
            <p>Aviso de pagamento (webhook){asInfo.webhook ? ', cadastrado no Asaas' : ''}:</p>
            <p className="font-mono text-xs break-all">{asInfo.webhook_url}</p>
            <p className="text-xs text-slate-500 pt-1">O saldo só é creditado depois que o app confirma o pagamento diretamente com o Asaas. Exige CPF/CNPJ no remetente (Configurações → Remetente) — sem isso, cai automaticamente pro InfinitePay.</p>
          </div>
        )}
      </section>

      <section className="bg-white rounded-2xl border border-slate-100 p-6">
        <h2 className="text-lg font-semibold text-slate-900">InfinitePay</h2>
        <p className="text-sm text-slate-500 mb-5">Recarga da carteira por Pix e cartão, com confirmação automática.</p>
        <form onSubmit={salvar} className="space-y-4">
          <label className="block">
            <span className="text-sm font-medium text-slate-700">InfiniteTag (handle)</span>
            <Input className="mt-1 max-w-xs" value={handle} onChange={(e) => setHandle(e.target.value)} required />
            <span className="block text-xs text-slate-500 mt-1">Sem o símbolo $. É a conta que recebe os pagamentos.</span>
          </label>
          {msg && <p className={`text-sm ${msg.ok ? 'text-emerald-600' : 'text-red-600'}`}>{msg.text}</p>}
          <Button type="submit" disabled={busy} className="inn-btn-primary rounded-full h-10 px-6">Salvar</Button>
        </form>
        {info && (
          <div className="mt-5 text-sm text-slate-600 bg-slate-50 rounded-xl p-4 space-y-1">
            <p>Recarga mínima: <strong>R$ {info.recarga_min.toFixed(2).replace('.', ',')}</strong> · máxima: <strong>R$ {info.recarga_max.toFixed(2).replace('.', ',')}</strong></p>
            <p>Aviso de pagamento (webhook), configurado automaticamente:</p>
            <p className="font-mono text-xs break-all">{info.webhook_url}</p>
            <p className="text-xs text-slate-500 pt-1">O saldo só é creditado depois que o app confirma o pagamento diretamente com o InfinitePay.</p>
          </div>
        )}
      </section>

      <section className="bg-white rounded-2xl border border-slate-100 p-6">
        <h2 className="text-lg font-semibold text-slate-900">Pagar.me</h2>
        <p className="text-sm text-slate-500 mb-5">Pix com QR code direto na tela da Carteira, sem redirecionar o cliente pra outro site.</p>
        <form onSubmit={salvarPagarme} className="space-y-4">
          <label className="block">
            <span className="text-sm font-medium text-slate-700">Chave secreta (Secret Key)</span>
            <Input type="password" className="mt-1" value={chave} onChange={(e) => setChave(e.target.value)}
              placeholder={pagarmeInfo?.tem_chave ? '•••••••••••••••••• (já salva)' : 'sk_test_... ou sk_...'} />
            <span className="block text-xs text-slate-500 mt-1">Painel do Pagar.me → Chaves de API. Use a "sk_test_" primeiro pra testar, sem risco.</span>
          </label>
          {msgPagarme && <p className={`text-sm ${msgPagarme.ok ? 'text-emerald-600' : 'text-red-600'}`}>{msgPagarme.text}</p>}
          <Button type="submit" disabled={busyPagarme || !chave.trim()} className="inn-btn-primary rounded-full h-10 px-6">Salvar</Button>
        </form>
        {pagarmeInfo && (
          <div className="mt-5 text-sm text-slate-600 bg-slate-50 rounded-xl p-4 space-y-1">
            <p>Status: {pagarmeInfo.tem_chave ? <strong className="text-emerald-600">Chave salva ({pagarmeInfo.ambiente})</strong> : <strong className="text-slate-400">Nenhuma chave salva</strong>}</p>
            <p>Aviso de pagamento (webhook), configurado automaticamente:</p>
            <p className="font-mono text-xs break-all">{pagarmeInfo.webhook_url}</p>
            <p className="text-xs text-slate-500 pt-1">O saldo só é creditado depois que o app confirma o pagamento diretamente com o Pagar.me. Exige que o cliente já tenha CPF/CNPJ cadastrado no remetente (Configurações → Remetente) — sem isso, cai automaticamente pro InfinitePay.</p>
          </div>
        )}
      </section>

      <section className="bg-white rounded-2xl border border-slate-100 p-6">
        <h2 className="text-lg font-semibold text-slate-900">Mercado Pago</h2>
        <p className="text-sm text-slate-500 mb-5">Pix com QR code direto na tela da Carteira, sem redirecionar o cliente pra outro site.</p>
        <form onSubmit={salvarMp} className="space-y-4">
          <label className="block">
            <span className="text-sm font-medium text-slate-700">Access Token</span>
            <Input type="password" className="mt-1" value={mpToken} onChange={(e) => setMpToken(e.target.value)}
              placeholder={mpInfo?.tem_chave ? '•••••••••••••••••• (já salvo)' : 'TEST-... ou APP_USR-...'} />
            <span className="block text-xs text-slate-500 mt-1">Painel do Mercado Pago → Suas integrações → Credenciais. Use a "TEST-" primeiro pra testar, sem risco.</span>
          </label>
          {msgMp && <p className={`text-sm ${msgMp.ok ? 'text-emerald-600' : 'text-red-600'}`}>{msgMp.text}</p>}
          <Button type="submit" disabled={busyMp || !mpToken.trim()} className="inn-btn-primary rounded-full h-10 px-6">Salvar</Button>
        </form>
        {mpInfo && (
          <div className="mt-5 text-sm text-slate-600 bg-slate-50 rounded-xl p-4 space-y-1">
            <p>Status: {mpInfo.tem_chave ? <strong className="text-emerald-600">Access Token salvo ({mpInfo.ambiente})</strong> : <strong className="text-slate-400">Nenhum token salvo</strong>}</p>
            <p>Aviso de pagamento (webhook), configurado automaticamente:</p>
            <p className="font-mono text-xs break-all">{mpInfo.webhook_url}</p>
            <p className="text-xs text-slate-500 pt-1">O saldo só é creditado depois que o app confirma o pagamento diretamente com o Mercado Pago. Exige que o cliente já tenha CPF/CNPJ cadastrado no remetente (Configurações → Remetente) — sem isso, cai automaticamente pro InfinitePay.</p>
          </div>
        )}
      </section>
    </div>
  );
};

export default PagamentosSection;
